/**
 * Cryptographically random identifier generator
 * Generates an anonymous ID with prefix 'a_' e.g. a_01j4k5m6n7p8q9r0...
 */
export function generateAnonymousId(): string {
  const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const length = 22;
  let result = "a_";

  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const randomBytes = new Uint8Array(length);
    crypto.getRandomValues(randomBytes);
    for (let i = 0; i < length; i++) {
      result += chars[randomBytes[i] % chars.length];
    }
  } else {
    // Fallback if crypto is unavailable
    for (let i = 0; i < length; i++) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
  }

  return result;
}

export function generateEventId(): string {
  const chars = "0123456789abcdef";
  let uuid = "evt_";
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    // Format as hex string
    for (let i = 0; i < 16; i++) {
      uuid += chars[bytes[i] >> 4] + chars[bytes[i] & 0x0f];
    }
  } else {
    uuid += Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
  }
  return uuid;
}

export function generateSessionId(): string {
  const chars = "0123456789abcdefghijklmnopqrstuvwxyz";
  let result = "s_";
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    for (let i = 0; i < 16; i++) {
      result += chars[bytes[i] % chars.length];
    }
  } else {
    result += Math.random().toString(36).substring(2, 12) + Date.now().toString(36);
  }
  return result;
}
